module.exports = __webpack_public_path__ + "img/button-home2.aecf4a1b.png";